/* import __COLOCATED_TEMPLATE__ from './diy-freelancer-analytics.hbs'; */
import EmberObject, { computed } from '@ember/object';
import DiyBaseAnalytics from './diy-base-analytics';
import ICON_PATH from '../../../constants/assets/icons';

// params
const EARNINGS = 'earnings';
const NAME = 'name';

const NAME_POOL = [
  'Conor McGlynn',
  'Ramona Prosacco',
  'Orlo Waters',
  'Rosanna Rippin',
  'Marlon Kirlin',
  'Reese Bailey',
  'Franco Collier',
  'Brent Jacobs',
  'Kyra Wilderman',
  'Dawn Kub'
];

const MIN_EARNINGS = 3000;
const MAX_EARNINGS = 12000;

export default DiyBaseAnalytics.extend({
  title: 'Track your freelancer earnings',
  text: 'View your freelancer spend, usage, activity and more by upgrading to a subscription plan.',
  icon: ICON_PATH.FREELANCER_REPORT,
  init() {
    this._super(...arguments);
    const freelancers = [];
    const namePool = Array.from(NAME_POOL);
    for (let i = 0; i < NAME_POOL.length; i++) {
      // move a random name to the front
      const idx = Math.floor(Math.random() * namePool.length);
      const tempName = namePool[0];
      namePool[0] = namePool[idx];
      namePool[idx] = tempName;

      freelancers.push(EmberObject.create({
        [EARNINGS]: Math.random() * (MAX_EARNINGS - MIN_EARNINGS) + MIN_EARNINGS,
        [NAME]: namePool.shift()
      }));
    }

    this.set('data', freelancers);
  },
  ///////////
  // CHART //
  ///////////
  chartLabelParam: NAME,
  chartKeyParam: NAME,
  sumParam: EARNINGS,

  chartLabels: computed('data', 'chartKeyParam', function() {
    const data = this.get('data');
    const keyParam = this.get('chartKeyParam');

    return data.reduce((labels, item) => {
      labels[item.get(keyParam)] = item.get(NAME);

      return labels;
    }, {});
  }),

  chartSumFormatter: computed('sumParam', function() {
    const sumParam = this.get('sumParam');
    switch (sumParam) {
      case EARNINGS:
        return this.formatMoneyWithoutChange.bind(this);
      default:
        return null;
    }
  }),
});
